import * as SelectPrimitive from '@radix-ui/react-select';
import * as Stitches from '@stitches/react';
import { styled } from '@gbm-tech/styles';

const SelectContainerMD: Stitches.CSS = {
  height: '4.8rem',
};

const SelectContainerLG: Stitches.CSS = {
  height: '5.2rem',
};

const FontMD: Stitches.CSS = {
  fontSize: '1.6rem',
  lineHeight: '2.8rem',
};

const FontLG: Stitches.CSS = {
  fontSize: '1.6rem',
  lineHeight: '2.8rem',
};

export const SelectContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1.2rem',

  height: '4rem',
  width: '$$width',
  minWidth: '2.4rem',

  border: '1px solid $gray200',
  borderRadius: '4px',

  transition: 'all 0.4s ease-in-out',

  '&:focus': {
    borderColor: '$blue700',
  },

  '&::-webkit-input-placeholder': {
    color: '$gray700',
    opacity: 0.5,
  },

  variants: {
    full: {
      true: {
        width: '100%',
      },

      false: {
        width: '$$width',
      },
    },

    size: {
      sm: {},

      md: {
        ...SelectContainerMD,
      },

      lg: {
        ...SelectContainerLG,
      },
    },

    withoutBorder: {
      true: {
        borderColor: 'transparent',
      },

      false: {},
    },
  },
});

const SelectTrigger = styled(SelectPrimitive.Trigger, {
  all: 'unset',
  height: '100%',
  width: '200px',
  padding: '0 1.6rem',

  flex: 1,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',

  color: '$gray700',
  fontWeight: 400,
  fontSize: '1.4rem',
  lineHeight: '2.4rem',

  backgroundColor: 'transparent',
  border: 0,
  outline: 0,

  '&[data-placeholder]': {
    opacity: 0.5,
  },

  '> span': {
    flex: 'initial',
  },

  '> span:first-child': {
    flex: 1,

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  variants: {
    size: {
      sm: {},

      md: {
        ...FontMD,
      },

      lg: {
        ...FontLG,
      },
    },
  },
});

const SelectIcon = styled(SelectPrimitive.Icon, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  fontSize: '2.4rem',
  color: '$gray700',
  opacity: 0.5,
});

const SelectValue = styled(SelectPrimitive.Value, {
  color: '$gray700',
});

export const SelectContent = styled(SelectPrimitive.Content, {
  overflow: 'hidden',
  // marginTop: '8rem',
  marginLeft: '3.2rem',

  backgroundColor: '$white',
  border: '1px solid $gray200',
  borderRadius: '4px',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
});

export const SelectScrollUpButton = styled(SelectPrimitive.ScrollUpButton, {
  height: '2.4rem',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  color: '$blue300',
});

export const SelectViewport = styled(SelectPrimitive.Viewport, {
  padding: '1.6rem',
});

export const SelectGroup = styled(SelectPrimitive.Group, {});

export const SelectLabel = styled(SelectPrimitive.Label, {
  fontWeight: 400,
  fontSize: '1.4rem',
  lineHeight: '2.4rem',

  color: '$gray400',

  variants: {
    size: {
      sm: {},

      md: {
        ...FontMD,
      },

      lg: {
        ...FontLG,
      },
    },
  },
});

export const SelectItem = styled(SelectPrimitive.Item, {
  all: 'unset',
  position: 'relative',
  padding: '0.8rem 1.6rem 0.8rem 3.2rem',

  display: 'flex',
  alignItems: 'center',

  fontWeight: 400,
  fontSize: '1.4rem',
  lineHeight: '2.4rem',

  color: '$gray600',

  '&[data-state=checked]': {},

  borderBottom: '1px solid transparent',
  userSelect: 'none',

  '&[data-disabled]': {
    opacity: 6.4,
  },

  '&[data-highlighted]': {
    backgroundColor: '$blue50',
    borderBottom: '1px solid $blue100',
  },

  variants: {
    size: {
      sm: {},

      md: {
        ...FontMD,
      },

      lg: {
        ...FontLG,
      },
    },
  },
});

export const SelectItemText = styled(SelectPrimitive.ItemText, {});

export const SelectItemIndicator = styled(SelectPrimitive.ItemIndicator, {
  position: 'absolute',
  left: 0,

  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',

  color: '$blue400',
});

export const SelectGroupContainer = styled('div', {
  width: '$$width',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',

  variants: {
    full: {
      true: {
        width: '100%',
      },

      false: {
        width: '$$width',
      },
    },
  },
});

export const SelectStyled = {
  Trigger: SelectTrigger,
  Icon: SelectIcon,
  Value: SelectValue,
  Content: SelectContent,
  ScrollUpButton: SelectScrollUpButton,
  ViewPort: SelectViewport,
  Group: SelectGroup,
  Label: SelectLabel,
  Item: SelectItem,
  ItemText: SelectItemText,
  ItemIndicator: SelectItemIndicator,
};
